<template>
  <section v-if="products && products.products.length > 0" style="width: 100%">
    <div class="d-flex flex-column flex pt-4">
      <Button 
        :disabled="selectedSection.itemsV2.length === 0"
        label="Configurar itens do ingresso" 
        color="bt_color_bg"
        :textColor="selectedSection.itemsV2.length === 0 ? '#B0B0B0' : 'bt_color'"
        textSize="0.80rem"
        icon="fa-regular fa-ticket"
        @click="handleOpenDialog"
      />
    </div>

    <Dialog2
      v-if="copySelectedSection"
      v-model="dialog" 
      :key="reRender"
      bgColor="#F7F8F8"
      bgTitleColor="white" 
      showTitleDivider 
      width="1080"
    >
      <template slot="title">
        <span class="_dialog-title2">Configurar itens do ingresso</span>
      </template>

      <template slot="content">
        <v-row 
          no-gutters 
          :class="[{'mx-6': $vuetify.breakpoint.mdAndUp}]"
          justify="end"
        >
          <v-col :cols="getColsItem.itemDesc"></v-col>
          <v-col :cols="getColsItem.items">
            <v-row no-gutters justify="end">
              <v-col 
                v-for="(ticket,index) in copySelectedSection.itemsV2" 
                :key="index"
                :cols="getCols" 
                @click="handleHighlightItem(ticket)"
              >
                <div :class="['ticket-container', {'ticket-container-highlight': ticket.destaque}]">
                  <div class="feature-text">
                    <i v-if="!ticket.destaque" class="fa-regular fa-circle" style="color: #D7D9E0"></i>
                    <i v-else class="fa-solid fa-circle-check" style="color: #0079CB"></i>
                    Destacar ingresso
                  </div>

                  <div 
                    class="d-flex justify-center pt-8" 
                    style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
                  >
                    <h1 
                      :ref="`ticket-title-${index}`" 
                      class="title" 
                      @mouseenter="isEllipsed(`ticket-title-${index}`)" 
                      @mouseleave="resetTooltip"
                    >
                      <v-tooltip bottom max-width="220" :disabled="!infoTooltip.show" color="#0079CB">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            {{getName(ticket)}}
                          </span>
                        </template>
                        <div :style="{'font-size': '0.8rem'}">
                          {{getName(ticket)}}
                        </div>
                      </v-tooltip>
                    </h1>
                  </div>

                  <div class="d-flex justify-center align-center">
                    <div class="price-detail pr-1">R$</div>
                    <h2 class="price">{{getValue(ticket)}}</h2>
                    <span class="price-detail pb-1">,00</span>
                  </div>     

                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <draggable ghost-class="ghost" :list="copySelectedSection.itemsV2Desc">
          <transition-group type="transition" name="list-complete"> 
            <section
              v-for="(itemGroup, indexItemGroup) in copySelectedSection.itemsV2Desc"
              :key="itemGroup.id"
              class="pt-1 pb-6"
            >
              <Expansion 
                v-model="itemGroup.isOpen" 
                :verticalExpansion="false"
                :defaultClass="$vuetify.breakpoint.mdAndUp ? 'mx-6' : ''"
              >
                <template slot="default">
                  <!-- <div 
                    v-if="itemGroup.noNamedGroup && copySelectedSection.itemsV2Desc.length === 1"
                    :class="['expansion-unnamed']"
                  ></div>    -->
                  <!-- <div v-else :class="['expansion-named']" :ref="itemGroup.id"> -->
                  <div :class="['expansion-named']" :ref="itemGroup.id">
                    <!-- <span v-if="itemGroup.noNamedGroup">{{'Sem grupo'}}</span> -->
                    <!-- <div v-else class="d-flex flex-column flex" style="z-index: 100"> -->
                    <div class="d-flex flex-column flex" style="z-index: 100">
                      <TextField
                        :placeholder="`Grupo ${indexItemGroup + 1} - sem nome`"
                        v-model="itemGroup.group"
                        backgroundColor="transparent"
                        width="50%"
                        :showBorder="false"
                        autofocus
                        customStyle="margin-left: -20px; font-size: 18px !important; font-weight: 700 !important; color: #B4B8C5 !important"
                      /> 
                    </div>

                    <div class="d-flex" style="gap: 16px">
                      <PopUpMenu 
                        v-if="!itemGroup.noNamedGroup" 
                        :options="getMenuOptions"
                        width="220px"
                        fontSize="13px"
                        @click="() => { indexOfGroupMenuClicked = indexItemGroup }"
                      ></PopUpMenu>                  
                      <ExpandedIcon2 :isExpanded="itemGroup.isOpen"/>
                    </div>
                  </div>            
                </template>

                <template slot="expanded">
                  <draggable 
                    ghost-class="ghost2" 
                    :list="itemGroup.items" 
                    group="itemGroup-row"
                    @add="(event) => { onChangeItemGroup(event, indexItemGroup)}"
                  >
                    <transition-group type="transition" name="list-complete">                           
                      <v-row 
                        v-for="(itemDesc, itemDescIndex) in itemGroup.items"
                        :key="itemDesc.id"
                        :class="['ticket-item-desc', {'mx-6': $vuetify.breakpoint.mdAndUp}]"
                        no-gutters 
                        justify="end"
                      >
                        <div v-if="itemDescIndex !== 0" class="ticket-item-desc-remove">
                          <DeleteButton2 @click="handleRemoveItemOfGroup(indexItemGroup, itemDescIndex, itemDesc.id)"/>
                        </div>

                        <v-col :cols="getColsItem.itemDesc" align-self="center" class="px-3">
                          <TextField
                            placeholder="Descreva o item"
                            v-model="itemDesc.description"
                            backgroundColor="white"
                            width="100%"
                            :showBorder="false"
                            customStyle="margin-left: 0px; font-size: 14px !important; font-weight: 400 !important; color: #B4B8C5 !important"
                          />               
                        </v-col>

                        <v-col :cols="getColsItem.items">
                          <v-row no-gutters justify="end">
                            <v-col v-for="(col, index) in copySelectedSection.itemsV2" :key="index" :cols="getCols" >
                              <div 
                                class="ticket-item-row" 
                                :style="{'--hover-row-color': hasItem(index, itemDesc.id) ? '#6DB2E1' : '#CBCBCE'}" 
                                @click="handleAddItemToTicket(index, itemDesc.id)"
                              >
                                <i 
                                  class="fa-solid fa-circle-check" 
                                  :style="{color: hasItem(index, itemDesc.id) ? '#0079CB' : '#EDEDF1'}"
                                ></i>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </transition-group>
                  </draggable>
                </template>
              </Expansion>

              <div class="pt-4 pl-6">
                <Button2 
                  label="Novo item" 
                  textColor="bt_color"
                  textSize="0.80rem"
                  icon="fa-solid fa-plus"
                  @click="handleAddNewItemInGroup(indexItemGroup)"
                />
              </div>
            </section>
          </transition-group>
        </draggable>
      </template>

      <template slot="actions">
        <div class="d-flex justify-space-between pb-2 pl-0" style="gap: 8px">
          <Button2 
            label="Novo Grupo" 
            textColor="bt_color"
            textSize="0.80rem"
            @click="handleCreateNewGroup"
          />

          <div class="d-flex" style="gap: 8px">
            <Button outlined label="Cancelar" text-color="bt_color" textSize="0.80rem" @click="handleCloseDialog"/>
            <Button label="Confirmar" textSize="0.80rem" @click="handleConfirm"/>
          </div>
        </div>
      </template>    
    </Dialog2>    
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import { TICKETS_LAYOUT_ITEMS_DESC } from '../../../../../schemas/sections'
import { changeNullForStringValue } from '../../../../../helpers/recursive'
import { generateId } from '../../../../../helpers/generateId'
import Button from '../../../../_v2/ui/Button.vue'
import Button2 from '../../../../_v2/ui/Button2.vue'
import Expansion from '../../../../_v2/ui/Expansion.vue'
import TextField from '../../../../_v2/ui/TextField.vue'
import DeleteButton2 from '../../../../_v2/ui/DeleteButton2.vue'
import Dialog2 from '../../../../_v2/ui/Dialog2.vue'
import PopUpMenu from '../../../../_v2/ui/PopUpMenu.vue'
import ExpandedIcon2 from '../../../../_v2/utils/ExpandedIcon2.vue'

export default {
  name: 'newLayoutDialog',
  components: { 
    draggable,
    Button, 
    Button2, 
    TextField, 
    Dialog2, 
    DeleteButton2, 
    Expansion, 
    ExpandedIcon2, 
    PopUpMenu 
  },
  props: {
    selectedSection: {type: Object, required: true},
  },

  computed: {
    ...mapGetters(['products']),

    getColsItem () {
      const size = this.copySelectedSection.itemsV2.length
      if (size === 1) return {itemDesc: '4', items: '8'}
      if (size === 2) return {itemDesc: '3', items: '9'}
      if (size === 3) return {itemDesc: '3', items: '9'}
      return {itemDesc: '3', items: '9'}
    },

    getCols () {
      const size = this.copySelectedSection.itemsV2.length
      if (size === 1) return '6'
      if (size === 2) return '6'
      if (size === 3) return '4'
      if (size === 4) return '3'
      return '12'
    },

    getMenuOptions () {
      const index = this.indexOfGroupMenuClicked
      return [
        {label: 'Duplicar grupo', action: () => { this.handleDuplicateGroup(index) }},
        {label: 'Remover todo o grupo', action: () => { this.handleRemoveGroup(index)}, divider: true },
        {label: 'Remover apenas o grupo', action: () => { this.handleRemoveOnlyGroup(index) }}
      ]
    }
  },

  data: () => ({
    indexOfGroupMenuClicked: null,
    dialog: false,
    reRender: 0,
    infoTooltip: {ref: '', show: false},
    copySelectedSection: null
  }),

  mounted () {
    this.copyObj()
  },

  methods: {
    copyObj () {
      const copy = JSON.parse(JSON.stringify(this.selectedSection))
      this.copySelectedSection = changeNullForStringValue(copy)
    },

    expandItens () {
      this.copySelectedSection.itemsV2Desc.forEach(group => {
        group.isOpen = true
      })
    },

    checkHasGroups () {
      const hasGroup = this.copySelectedSection.itemsV2Desc.length > 0
      if (!hasGroup) {
        const newGroup = TICKETS_LAYOUT_ITEMS_DESC()
        const id = generateId()
        newGroup.id = id
        newGroup.noNamedGroup = true
        newGroup.isOpen = true
        newGroup.items[0].id = `${id}-${generateId()}` 

        this.copySelectedSection.itemsV2Desc.push(newGroup)
      }

      if (hasGroup) {
        const groups = this.copySelectedSection.itemsV2Desc
        groups.forEach(group => {
          if (group.items.length === 0) {
            const newItem = {id: `${group.id}-${generateId()}`, description: ''}
            group.items.push(newItem)
          }
        })
      }
    },

    handleOpenDialog () {
      this.copyObj()
      this.expandItens()
      this.checkHasGroups()
      this.dialog = true
      this.reRender++
    },

    handleCloseDialog () {
      this.dialog = false
    },

    handleConfirm () {
      const itemsV2 = JSON.parse(JSON.stringify(this.copySelectedSection.itemsV2))
      this.selectedSection.itemsV2 = changeNullForStringValue(itemsV2)

      const itemsV2Desc = JSON.parse(JSON.stringify(this.copySelectedSection.itemsV2Desc))
      const itemsV2DescParsed = changeNullForStringValue(itemsV2Desc)
      this.selectedSection.itemsV2Desc = itemsV2DescParsed

      this.handleCloseDialog()
    },

    isEllipsed (ref) {
      const cardTitle = this.$refs[ref]
      const isCardTitleEllipsed = cardTitle[0].scrollWidth > cardTitle[0].clientWidth
      Object.assign(this.infoTooltip, {ref, show: isCardTitleEllipsed})  
    },

    resetTooltip () {
      Object.assign(this.infoTooltip, {ref: '', show: false})  
    },

    getName (ticket) {
      const {codigo, codigo_tipo} = ticket
      const product = this.products.products.find(item => item.codigo_tipo === codigo_tipo && item.codigo_produto === codigo)
      let productName = 'Ingresso'

      if (product) {
        productName = product.nome_tipo ? `${product.nome} - ${product.nome_tipo}` : product.nome
      }
      
      return productName
    },

    getValue (ticket) {
      const {codigo, codigo_tipo} = ticket
      const product = this.products.products.find(item => item.codigo_tipo === codigo_tipo && item.codigo_produto === codigo)
      const price = product.valor ? String(product.valor) : '0'

      const formatedValue = price.split(',00')[0]
      return formatedValue
    },

    handleHighlightItem (ticket) {
      ticket.destaque = !ticket.destaque
      const ticketId = `${ticket.codigo}-${ticket.codigo_tipo}`

      this.copySelectedSection.itemsV2.forEach(item => {
        const id = `${item.codigo}-${item.codigo_tipo}`
        if (id !== ticketId) item.destaque = false
      })
    },

    handleAddItemToTicket (index, itemId) {
      const ticket = this.copySelectedSection.itemsV2[index]
      const hasItem = ticket.itens_incluidos.find(id => id === itemId)
      if (!hasItem) ticket.itens_incluidos.push(itemId)
      else ticket.itens_incluidos = ticket.itens_incluidos.filter(id => id !== itemId)
    },

    hasItem (index, itemId) {
      const ticket = this.copySelectedSection.itemsV2[index]
      const hasItem = ticket.itens_incluidos.find(id => id === itemId)
      return hasItem ? true : false      
    },

    handleAddNewItemInGroup (index) {
      const group = this.copySelectedSection.itemsV2Desc[index]
      const newItem = {id: `${group.id}-${generateId()}`, description: ''}
      group.items.push(newItem)
      group.isOpen = true
    }, 

    handleRemoveItemOfGroup (indexGroup, indexItem, idItem) {
      this.copySelectedSection.itemsV2Desc[indexGroup].items.splice(indexItem, 1)
      this.copySelectedSection.itemsV2.forEach(ticket => {
        ticket.itens_incluidos = ticket.itens_incluidos.filter(id => id !== idItem)
      })
    },

    handleCreateNewGroup () {
      const newGroup = TICKETS_LAYOUT_ITEMS_DESC()
      const id = generateId()
      newGroup.id = id
      newGroup.isOpen = true
      newGroup.items[0].id = `${id}-${generateId()}` 

      this.copySelectedSection.itemsV2Desc.push(newGroup)
      setTimeout(() => { 
        const newGroupHtml = this.$refs[id][0]
        newGroupHtml.scrollIntoView({ behavior: 'smooth' })
       }, 100)
    },

    handleDuplicateGroup (index) {
      const newId = generateId()
      let group = JSON.parse(JSON.stringify(this.copySelectedSection.itemsV2Desc[index]))
      group = changeNullForStringValue(group)
      group.id = newId
      group.group += ' cópia'
      group.items.forEach((item) => {
        item.id = `${newId}-${generateId()}`
      })
      this.copySelectedSection.itemsV2Desc.push(group)
    },

    handleRemoveGroup (index) {
      const group = this.copySelectedSection.itemsV2Desc[index]
      const groupItems = group.items.map(item => item.id)

      this.copySelectedSection.itemsV2Desc.splice(index, 1)
      this.copySelectedSection.itemsV2.forEach(ticket => {
        ticket.itens_incluidos = ticket.itens_incluidos.filter(id => !groupItems.includes(id))
      })
    },

    handleRemoveOnlyGroup (index) {
      const unnamedGroup = this.copySelectedSection.itemsV2Desc.find(group => group.noNamedGroup)
      let group = JSON.parse(JSON.stringify(this.copySelectedSection.itemsV2Desc[index]))
      group = changeNullForStringValue(group)

      const updatedIds = {}

      group.items.forEach(item => {
        const oldId = item.id.split('-')
        const newId = `${unnamedGroup.id}-${oldId[1]}`
        updatedIds[item.id] = newId
        unnamedGroup.items.push({id: newId, description: item.description})
      })

      this.copySelectedSection.itemsV2Desc.splice(index, 1)
      this.copySelectedSection.itemsV2.forEach(ticket => {
        ticket.itens_incluidos.forEach((id, index) => {
          if (updatedIds[id]) {
            this.$set(ticket.itens_incluidos, index, updatedIds[id])
          } 
        })
      })      
    },

    onChangeItemGroup(event, groupItemIndex) {
      const {newIndex: index} = event
      const itemBeforeFixId = JSON.parse(JSON.stringify(this.copySelectedSection.itemsV2Desc[groupItemIndex].items[index].id))
      const currentGroupId = this.copySelectedSection.itemsV2Desc[groupItemIndex].id
      const itemNewId = `${currentGroupId}-${itemBeforeFixId.split('-')[1]}`

      this.copySelectedSection.itemsV2Desc[groupItemIndex].items[index].id = itemNewId

      this.copySelectedSection.itemsV2.forEach((ticket) => {
        ticket.itens_incluidos.forEach((itemIncluido, itemIncluidoIndex) => {
          if (itemIncluido === itemBeforeFixId) {
            this.$set(ticket.itens_incluidos, itemIncluidoIndex, itemNewId)
          }
        })
      })

      this.copySelectedSection.itemsV2Desc.forEach((itemsDesc, indexItemsDesc) => {
        if (itemsDesc.items.length === 0) this.handleAddNewItemInGroup(indexItemsDesc)
      }) 

      console.log(this.copySelectedSection.itemsV2Desc)
    }     
  }
}
</script>

<style scoped>
.ticket-container {
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 8px 0px 8px 12px;
  padding: 16px;
  border-radius: 12px;
  transition: all 0.5s;
  cursor: pointer;
  border: 1px solid white;
}

.ticket-container-highlight {
  background-color: #F0F8FF !important;
  border: 1px solid #B9E2FE;
}

.ticket-container .feature-text {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: #3C4B62;
  gap: 8px
}

.ticket-container .title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 24px;
  line-height: 124%;
  padding-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ticket-container .price {
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 700;
  color: #0079CB
}

.ticket-container .price-detail {
  font-size: 12px;
  letter-spacing: 0;
  color: #0079CB  
}

.expansion-unnamed {
  display: flex;
  justify-content: end;
  margin-bottom: 8px;
}

.expansion-named {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  background-color: #F0F8FF;
  border-radius: 8px;
  padding: 8px 20px 8px 20px;
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
}

.expansion-named:hover {
  cursor: pointer;
  animation: changeCursor 3s forwards;  
}

.ticket-item-desc {
  position: relative; 
  border-radius: 12px; 
  border: 1px solid #EDEDF1 !important;
  background-color: white;
}

.ticket-item-desc-remove {
  position: absolute; 
  top: 30%; 
  right: -32px; 
  z-index: 10
}

.ticket-item-row {
  background-color: white;
  margin: 8px 0px 8px 12px;
  padding: 4px 12px 4px 12px;
  border-radius: 12px;
  text-align: center;
  font-size: 28px;
  cursor: pointer
}

i {
  transition: all 0.5s
}

.ticket-item-row:hover i {
  color: var(--hover-row-color) !important
}

/* Draggable style  */
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move !important
}

.ghost2 {
  opacity: 0.7;
  background: #c8ebfb;
  cursor: move !important
}

.list-complete-item {
  transition: all 0.8s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-complete-leave-active {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
}

@keyframes changeCursor {
  100% {
    cursor: move;
  }
}
</style>
